import { render, staticRenderFns } from "./quick.vue?vue&type=template&id=d9fd27d0&scoped=true&"
import script from "./quick.vue?vue&type=script&lang=js&"
export * from "./quick.vue?vue&type=script&lang=js&"
import style0 from "./quick.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./quick.vue?vue&type=style&index=1&id=d9fd27d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9fd27d0",
  null
  
)

export default component.exports